import { cn } from "@/lib/utils";

import PageTitle, { PageTitleProps } from "@/components/Common/PageTitle";
import { useShortcutSubContext } from "@/context/ShortcutContext";

interface PageProps extends PageTitleProps {
  children: React.ReactNode | React.ReactNode[];
  options?: React.ReactNode | React.ReactNode[];
  changePageMetadata?: boolean;
  className?: string;
  hideTitleOnPage?: boolean;
  shortCutContext?: string;
  style?: React.CSSProperties;
  titleLayout?: "md" | "lg";
}

export default function Page(props: PageProps) {
  useShortcutSubContext(props.shortCutContext);

  return (
    <div className={cn("md:px-6 py-0", props.className)} style={props.style}>
      <div
        className={cn(
          "flex flex-col justify-between gap-2 px-3 md:px-0",
          props.titleLayout === "lg"
            ? "lg:flex-row lg:items-center lg:gap-6"
            : "md:flex-row md:items-center md:gap-6",
        )}
      >
        <PageTitle
          changePageMetadata={props.changePageMetadata}
          title={props.title}
          componentRight={props.componentRight}
          isInsidePage={true}
          hideTitleOnPage={props.hideTitleOnPage}
        />
        {props.options}
      </div>
      {props.children}
    </div>
  );
}
